<template>
	<BaseLink :link="link" :click-text="clickText" :mixpanel-target="listItemConfig.heading">
		<ListItem class="list-item-link" :list-item-config="listItemConfig">
			<template #icon>
				<slot name="icon"></slot>
			</template>
			<template #heading>
				<slot name="heading"></slot>
			</template>
			<template v-if="listItemConfig.subheading || $slots.subheading" #subheading>
				<slot name="subheading"></slot>
			</template>
			<template #tag>
				<slot name="tag"></slot>
			</template>
			<template #control>
				<slot name="control"></slot>
			</template>
		</ListItem>
	</BaseLink>
</template>

<script setup lang="ts">
import { Link } from 'types/layout';
import ListItem from '@components/form/list-item/list-item.vue';
import { ListItemConfig } from 'types/form';

interface Props {
	clickText?: string;
	listItemConfig: ListItemConfig;
	link: Link;
}

withDefaults(defineProps<Props>(), {
	clickText: ''
});
</script>

<style lang="scss" scoped>
@use '../../../styles/constants/colors' as *;

a:has(.list-item):focus-visible {
	outline: none;

	& .list-item {
		outline: 2px solid token('info');
	}
}
</style>
